var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDiagonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7692 11.1188C12.7846 11.1188 13.0793 10.9423 13.4238 10.7265C13.7685 10.5107 14.0436 10.3212 14.0354 10.3055C14.0271 10.2898 13.8616 10.0663 13.6676 9.80887C13.278 9.29193 12.9029 8.60844 12.7366 8.11265C12.2186 6.56743 12.457 4.96287 13.3972 3.66769L13.6365 3.33787L13.1808 2.88215L12.7251 2.42639L12.4238 2.64107C10.4502 4.04756 8.08479 3.88572 5.98766 2.20079C5.85073 2.09076 5.73365 2.00585 5.72746 2.01204C5.67046 2.06903 4.95363 3.24108 4.9538 3.27697C4.95392 3.30292 5.07929 3.40908 5.23239 3.51279C6.92753 4.66135 8.86704 5.03584 10.3662 4.50416L10.7259 4.37663L5.72603 9.39469L2.56445 12.5678L3.48676 13.4901L6.66802 10.3204L11.6743 5.33235L11.5226 5.79567C11.129 6.99763 11.2902 8.42211 11.9825 9.85825C12.1796 10.2674 12.7109 11.1185 12.7692 11.1188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiagonal);
export default __webpack_public_path__ + "static/media/arrow-diagonal.09214f75811b7e08ef18e139b87728b7.svg";
export { ForwardRef as ReactComponent };